import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
  import interactiveMasterplanApi from "@/services/api/interactiveMasterplanApi";

  interface SvgElement {
    elementIndex: number;
    type: "rect" | "path" | "polygon" | "circle";
    id?: string;
    boundingBox: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
    rawAttributes: Record<string, string>;
  }

  interface ParseResult {
    elements: SvgElement[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'MasterplanUpload',
  props: {
    estateId: {}
  },
  emits: ["upload-success"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const fileInput = ref<HTMLInputElement | null>(null);
  const selectedFile = ref<File | null>(null);
  const isDragging = ref(false);
  const uploading = ref(false);
  const parseResult = ref<ParseResult | null>(null);

  const elementsByType = computed(() => {
    if (!parseResult.value) return { rect: 0, path: 0, polygon: 0, circle: 0 };

    return parseResult.value.elements.reduce(
      (acc, el) => {
        acc[el.type] = (acc[el.type] || 0) + 1;
        return acc;
      },
      { rect: 0, path: 0, polygon: 0, circle: 0 } as Record<string, number>
    );
  });

  const triggerFileSelect = () => {
    fileInput.value?.click();
  };

  const handleFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];

    if (file) {
      if (!file.name.endsWith(".svg") && file.type !== "image/svg+xml") {
        alert("Please select an SVG file");
        return;
      }

      selectedFile.value = file;
    }
  };

  const handleDragOver = () => {
    isDragging.value = true;
  };

  const handleDragLeave = () => {
    isDragging.value = false;
  };

  const handleDrop = (event: DragEvent) => {
    isDragging.value = false;

    const file = event.dataTransfer?.files[0];

    if (file) {
      if (!file.name.endsWith(".svg") && file.type !== "image/svg+xml") {
        alert("Please select an SVG file");
        return;
      }

      selectedFile.value = file;
    }
  };

  const clearFile = () => {
    selectedFile.value = null;
    parseResult.value = null;

    if (fileInput.value) {
      fileInput.value.value = "";
    }
  };

  const clearAll = () => {
    clearFile();
  };

  const handleParseSvg = async () => {
    if (!selectedFile.value) return;

    uploading.value = true;

    try {
      const formData = new FormData();

      formData.append("file", selectedFile.value);

      const response = await interactiveMasterplanApi.parseSvg(formData);

      parseResult.value = response.data;
    } catch (error) {
      console.error("Failed to parse SVG:", error);
      alert("Failed to parse SVG file. Please check the file and try again.");
      parseResult.value = null;
    } finally {
      uploading.value = false;
    }
  };

  const handleContinue = () => {
    if (!selectedFile.value || !parseResult.value) return;

    emit("upload-success", {
      svgFile: selectedFile.value,
      elements: parseResult.value.elements,
    });
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes < 1024) return `${bytes} B`;

    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

const __returned__ = { props, emit, fileInput, selectedFile, isDragging, uploading, parseResult, elementsByType, triggerFileSelect, handleFileSelect, handleDragOver, handleDragLeave, handleDrop, clearFile, clearAll, handleParseSvg, handleContinue, formatFileSize, ref, computed, get interactiveMasterplanApi() { return interactiveMasterplanApi } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})